var map = {
	"./drawing-course-photos/course1.jpeg": 4866,
	"./drawing-course-photos/course2.jpeg": 8463,
	"./drawing-course-photos/course3.jpeg": 1048,
	"./drawing-course-photos/poster.webp": 1771,
	"./logo.png": 3153,
	"./logos/fb.png": 4755,
	"./logos/ig.png": 391,
	"./logos/ig.svg": 8165,
	"./photos/h1.jpg": 6313,
	"./photos/h2.jpg": 6718,
	"./photos/h3.jpg": 1675,
	"./photos/h4.jpg": 88,
	"./photos/h5.jpg": 4053,
	"./photos/h6.jpg": 9850,
	"./photos/h7.jpg": 1015,
	"./photos/out1.jpg": 6193,
	"./photos/out2.jpg": 4774,
	"./photos/out3.jpg": 9475,
	"./photos/out4.jpg": 4672,
	"./photos/out5.jpg": 1773,
	"./photos/out6.jpg": 9634,
	"./photos/s1.jpg": 9752,
	"./photos/s2.jpg": 679,
	"./photos/s3.jpg": 9514,
	"./photos/s4.jpg": 5977,
	"./photos/s5.jpg": 4364,
	"./photos/s6.jpg": 1339,
	"./photos/s7.jpg": 6382,
	"./photos/s8.jpg": 4125,
	"./svgs/arrow.svg": 7189,
	"./svgs/arrow_left.svg": 4243,
	"./svgs/arrow_right.svg": 502,
	"./videos/rocne_obdobia.mp4": 5611,
	"./videos/rocne_obdobia.webm": 6481,
	"./videos/rocne_obdobia_spomal-50fps.mp4": 5709,
	"./videos/rocne_obdobia_spomal-50fps.webm": 6999
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;